import React, { useState, useEffect } from 'react';
import apiService from '../../../services/api';
import PurpleWhiteButton from '../PurpleWhiteButton/PurpleWhiteButton';
import './TripCountdown.css';

const TripCountdown = ({ size = 'default', showRequestButton = true, className = '' }) => {
  const [postingDate, setPostingDate] = useState(null);
  const [loadingDate, setLoadingDate] = useState(true);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  // Fetch the next visit date
  useEffect(() => {
    const fetchDate = async () => {
      setLoadingDate(true);
      try {
        const response = await apiService.config.getPostingDate();
        if (response.data.success && response.data.data.postingDate) {
          setPostingDate(new Date(response.data.data.postingDate));
        } else {
          setPostingDate(null);
          console.error("Failed to fetch posting date or date not set.");
        }
      } catch (error) {
        console.error('Error fetching posting date:', error);
        setPostingDate(null);
      } finally {
        setLoadingDate(false);
      }
    };
    fetchDate();
  }, []);

  // Calculate the time left
  function calculateTimeLeft() {
    if (!postingDate) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    const difference = postingDate - new Date();
    if (difference <= 0) {
      return { days: 0, hours: 0, minutes: 0, seconds: 0 };
    }
    return {
      days: Math.floor(difference / (1000 * 60 * 60 * 24)),
      hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
      minutes: Math.floor((difference / 1000 / 60) % 60),
      seconds: Math.floor((difference / 1000) % 60)
    };
  }

  // Update the countdown every second
  useEffect(() => {
    if (postingDate) {
      const timer = setInterval(() => {
        setTimeLeft(calculateTimeLeft());
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [postingDate]);

  const formatTimeUnit = (unit) => {
    return unit < 10 ? `0${unit}` : unit;
  };

  return (
    <div className={`trip-countdown ${size === 'large' ? 'trip-countdown-large' : ''} ${className}`}>
      <div className="countdown-box">
        {loadingDate ? (
          <>
            <div className="countdown-labels" aria-hidden="true">
              <div className="countdown-label-item">DAYS</div>
              <div className="countdown-label-item">HOURS</div>
              <div className="countdown-label-item">MINUTES</div>
              <div className="countdown-label-item">SECONDS</div>
            </div>
            <div className="countdown-display" aria-hidden="true">
              <span className="countdown-number countdown-skeleton">00</span>
              <span className="countdown-colon">:</span>
              <span className="countdown-number countdown-skeleton">00</span>
              <span className="countdown-colon">:</span>
              <span className="countdown-number countdown-skeleton">00</span>
              <span className="countdown-colon">:</span>
              <span className="countdown-number countdown-skeleton">00</span>
            </div>
          </>
        ) : postingDate ? (
          <>
            <div className="countdown-labels">
              <div className="countdown-label-item">DAYS</div>
              <div className="countdown-label-item">HOURS</div>
              <div className="countdown-label-item">MINUTES</div>
              <div className="countdown-label-item">SECONDS</div>
            </div>
            <div className="countdown-display">
              <span className="countdown-number">{formatTimeUnit(timeLeft.days)}</span>
              <span className="countdown-colon">:</span>
              <span className="countdown-number">{formatTimeUnit(timeLeft.hours)}</span>
              <span className="countdown-colon">:</span>
              <span className="countdown-number">{formatTimeUnit(timeLeft.minutes)}</span>
              <span className="countdown-colon">:</span>
              <span className="countdown-number">{formatTimeUnit(timeLeft.seconds)}</span>
            </div>
            {showRequestButton && size === 'large' && (
              <PurpleWhiteButton to="/request-item" text="Send a Request" />
            )}
          </>
        ) : (
          <div className="countdown-tbd">Next trip date to be announced</div>
        )}
      </div>
    </div>
  );
};

export default TripCountdown;